export default "__VITE_ASSET__DjtQb2PA__"